import { render, staticRenderFns } from "./warnTip.vue?vue&type=template&id=3bcd7e74&scoped=true"
import script from "./warnTip.vue?vue&type=script&lang=js"
export * from "./warnTip.vue?vue&type=script&lang=js"
import style0 from "./warnTip.vue?vue&type=style&index=0&id=3bcd7e74&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd7e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcd7e74')) {
      api.createRecord('3bcd7e74', component.options)
    } else {
      api.reload('3bcd7e74', component.options)
    }
    module.hot.accept("./warnTip.vue?vue&type=template&id=3bcd7e74&scoped=true", function () {
      api.rerender('3bcd7e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warn/warnTip.vue"
export default component.exports